import { render, staticRenderFns } from "./HeaderHidden.vue?vue&type=template&id=0f288ccf&lang=pug&"
import script from "./HeaderHidden.vue?vue&type=script&lang=js&"
export * from "./HeaderHidden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports